export enum StoreKey {
  CHM_CONNECTIONS = 'chmConnections',
  RESERVATION_ROOM_LOOKUP = 'reservationRoomLookup',
  ICAL_VIEWER = 'icalViewer',
  CONTACT_PERSONS = 'contactPersons',
  CONTRACTS = 'contracts',
  EMPLOYEES = 'employees',
  API_USERS_PAGE = 'apiUsersPage',
  INTEGRATION_PARTNERS = 'integrationPartners',
  PMS_VERSION_OVERRIDES = 'pmsVersionOverrides',
  PMS_VERSION_OVERRIDE_STATISTICS = 'pmsVersionOverrideStatistics',
  NTAK_VERSION = 'ntakVersion',
  PROPERTY_GROUPS = 'propertyGroups',
  REFERENCE_SETS = 'referenceSets',
  SALES_CASES_DATA_TABLE = 'salesCasesDataTable',
  SALES_CASES_KANBAN = 'salesCasesKanban',
  SALES_CASES_MAP = 'salesCasesMap',
  SALES_CASES_SUMMARY = 'salesCasesSummary',
  SALES_DASHBOARD = 'salesDashboard',
  SALESMEN = 'salesmen',
  USER = 'user',
  USER_ACTIVITY = 'userActivity',
  USER_GROUPS = 'userGroups',
}
